export const DEFAULT_PUBLIC_PLATFORM_SUPPORT_SETTINGS = {
  legalDetails: {
    phone: "+79658766068",
  },
  supportLinks: {
    telegramUrl: "https://t.me/tok_55",
    maxUrl: "https://max.ru/u/f9LHodD0cOLjqQZJ91Ux8HfRT17g6mdf5kkPEX-g_2Geg6nskDAAS03SdAw",
  },
} as const;

export const DEFAULT_PLATFORM_SETTINGS = {
  legalDetails: {
    serviceName: "Запись24",
    tariffPrice: "0 ₽ для мастеров",
    firstFreeUsage: "основной продукт доступен бесплатно без лимита онлайн-записей",
    owner: "ИП Кириченко Анатолий Сергеевич",
    inn: "550113317815",
    ogrnip: "318554300080153",
    email: "po80i40@gmail.com",
    phone: DEFAULT_PUBLIC_PLATFORM_SUPPORT_SETTINGS.legalDetails.phone,
    address: "Россия, г. Омск, ул. Энергетиков, д. 70",
  },
  supportLinks: DEFAULT_PUBLIC_PLATFORM_SUPPORT_SETTINGS.supportLinks,
  ownerNotifications: {
    channel: "MAX",
  },
} as const;

export function buildMailtoHref(email: string): string {
  return `mailto:${email.trim()}`;
}

export function buildTelHref(phone: string): string {
  const trimmed = phone.trim();
  const digits = trimmed.replace(/\D/g, "");

  if (digits.length === 10) return `tel:+7${digits}`;
  if (digits.length === 11 && digits.startsWith("8")) return `tel:+7${digits.slice(1)}`;
  if (digits.length >= 5) return `tel:+${digits}`;

  return `tel:${trimmed}`;
}
